import { createModal } from '/@/core/elements/modal'

export interface RegWallModalData {
  message: string | null
}

const { api, component } = createModal<RegWallModalData>(
  'RegWallModal',
  () => import('./RegWallModal.vue'),
  {
    message: null,
  },
)

export const useRegWallModal = api
export default component
